import './DeckSwitchButton.css';
import { DECKS, nextDeckId } from '../../constants/decks';
import { useDeck } from '../../context/useDeck';

/**
 * The deck switcher — a small control pinned to the top-right of the main
 * page. Shows the deck currently on the table; one tap cycles through the
 * available decks (Thoth → Sola Busca → Rider Waite → Thoth).
 */
export function DeckSwitchButton() {
    const { deckId, cycleDeck } = useDeck();
    const active = DECKS[deckId];
    const next = DECKS[nextDeckId(deckId)];

    return (
        <button
            className="deck-switch-button"
            onClick={cycleDeck}
            title={`Switch deck — currently ${active.label}, tap for ${next.label}`}
            aria-label={`Change tarot deck. Current deck: ${active.label}.`}
        >
            <span className="deck-switch-glyph" aria-hidden="true">⇄</span>
            <span className="deck-switch-label">{active.label}</span>
        </button>
    );
}
